import { RowBrandDto } from "@/dtos";
import { Brand } from "@/entities";

export const formatRowBrands = (brands: Brand[]): RowBrandDto[] => {
    return brands.map(x => {
        const row: RowBrandDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}